const chargeMapDetail = () => import('@/pages/chargeOrder/chargeMapDetail')
const chargeOrder = () => import('@/pages/chargeOrder/index')
const chargeOrderForm = () => import('@/pages/chargeOrder/chargeOrderForm')
const createChargeOrder = () => import('@/pages/chargeOrder/createChargeOrder')
const chargeOrderDetail = () => import('@/pages/chargeOrder/chargeOrderDetail')
const chargeAddkitCreate = () => import('@/pages/chargeOrder/chargeAddkitCreate')
const chargeApplyCreate = () => import('@/pages/chargeOrder/chargeApplyCreate')
const chargeAddkitList = () => import('@/pages/chargeOrder/chargeAddkitList')
const chargeRegisterList = () => import('@/pages/chargeOrder/chargeRegisterList')
const chargeRegisterCreate = () => import('@/pages/chargeOrder/chargeRegisterCreate')
const chargeOrderDetailPop = () => import('@/pages/chargeOrder/chargeOrderDetailPop')
const chargeOrderDetailregister = () => import('@/pages/chargeOrder/chargeOrderDetailregister')
export default [
  {
    path: '/chargeOrder',
    name: '/chargeOrder',
    component: chargeOrder,
    meta: {
      storeKey: 'trs.chargeOrder'
    }
  }, {
    path: '/chargeOrderForm',
    name: 'ChargeOrderForm',
    component: chargeOrderForm,
    meta: {
      cache: true
    }
  },
  {
    path: '/createChargeOrder',
    name: 'CreateChargeOrder',
    component: createChargeOrder,
    meta: {
      cache: true
    }
  },
  {
    path: '/chargeMapDetail',
    name: 'chargeMapDetail',
    component: chargeMapDetail,
    meta: {
    }
  },
  {
    path: '/chargeOrderDetail',
    name: '/chargeOrderDetail',
    component: chargeOrderDetail,
    meta: {
      storeKey: 'trs.chargeOrder'
    }
  },
  {
    path: '/chargeAddkitCreate',
    name: '/chargeAddkitCreate',
    component: chargeAddkitCreate,
    meta: {
    }
  },
  {
    path: '/chargeApplyCreate',
    name: '/chargeApplyCreate',
    component: chargeApplyCreate,
    meta: {
    }
  },
  {
    path: '/chargeAddkitList',
    name: '/chargeAddkitList',
    component: chargeAddkitList,
    meta: {
    }
  },
  {
    path: '/chargeRegisterList',
    name: '/chargeRegisterList',
    component: chargeRegisterList,
    meta: {
    }
  },
  {
    path: '/chargeRegisterCreate',
    name: '/chargeRegisterCreate',
    component: chargeRegisterCreate,
    meta: {
    }
  },
  {
    path: '/chargeOrderDetailPop',
    name: '/chargeOrderDetailPop',
    component: chargeOrderDetailPop,
    meta: {}
  },
  {

    path: '/chargeOrderDetailregister',
    name: '/chargeOrderDetailregister',
    component: chargeOrderDetailregister,
    meta: {}
  }
]



// WEBPACK FOOTER //
// ./src/router/chargeOrder/index.js